<template>
  <b-card no-body>

    <b-form>
      <b-card-header>
        <b-row>
          <b-col xl="6">
            <h4 class="h3 mb-0">Search Criteria</h4>
          </b-col>

          <b-col xl="6" class="text-right">
            <base-button type="primary" title="Search" size="sm" v-on:click="searchSubmit(true)" :loading="loadingStatus">
                <i v-if="!loadingStatus" class="fas fa-search">  </i>  Search
            </base-button>
            <base-button type="white" title="Clear" size="sm" v-on:click="defaultSearchKey(true)">
                <i class="fa fa-times mr-2"></i>Clear
            </base-button>
          </b-col>
        </b-row>

      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col xl="2" md="4" xs="6">
            <label for="fromDate" class="font-weight-900 text-sm">From Date:</label>
            <base-input v-model="overWatchForm.fromDate" type="datetime-local"
                        id="fromDate"/>
          </b-col>

          <b-col xl="2" md="4" xs="6">
            <label for="toDate" class="font-weight-900 text-sm">To Date:</label>
            <base-input v-model="overWatchForm.toDate" type="datetime-local" id="toDate"/>
          </b-col>

          <b-col xl="2" md="4" xs="6">
            <label for="imsiInfo" class="font-weight-900 text-sm">IMSI:</label>
            <b-form-input id="imsiInfo" type="number" v-model="overWatchForm.imsiInfo"
                          placeholder="IMSI"></b-form-input>
          </b-col>

          <b-col xl="2" md="4" xs="6">
            <label for="tId" class="font-weight-900 text-sm">TID:</label>
            <b-form-input id="tId" type="text" v-model="overWatchForm.tId" placeholder="TID"></b-form-input>
          </b-col>

          <b-col xl="2" md="4" xs="6">
            <label for="rowLimit" class="font-weight-900 text-sm">Row Limit:</label>
            <b-form-select
              id="rowLimit"
              v-model="overWatchForm.rowLimit"
              :options="rowLimitOption"
              value-field="key"
              text-field="key"
            ></b-form-select>
          </b-col>

          <b-col xl="2" md="4" xs="6">
            <label for="order" class="font-weight-900 text-sm">Order:</label>
            <b-form-select
              id="order"
              v-model="overWatchForm.order"
              :options="orderOption"
              value-field="value"
              text-field="key"
            ></b-form-select>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col xl="2" md="4" xs="6">
            <label for="standard" class="font-weight-900 text-sm">Standard:</label>
            <b-form-select
              id="standard"
              v-model="overWatchForm.standard"
              :options="standardOption"
              value-field="standard_id"
              placeholder="standard"
              text-field="standard_name"
            ></b-form-select>
          </b-col>

          <b-col xl="6" md="8" xs="6">
            <label for="type" class="font-weight-900 text-sm">Type:</label>

            <base-input label="">
              <el-select v-model="overWatchForm.type"
                         id="type"
                         filterable
                         collapse-tags
                         :remote="true"
                         placeholder="Filter by specific op codes...">
                <el-option v-for="option in typeOption"
                           :key="option.key"
                           :label="option.value"
                           :value="option.value">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>
      </b-card-body>
    </b-form>
  </b-card>
</template>

<script>
  import { Select, Option } from 'element-ui'
  import overwatchService from "../../../../common/api-services/overwatch-service";
  import dateFormatDirective from "../../../../common/directive/dateformat-directive";
  import configDirective from '../../../../common/directive/config-directive'
  import moment from 'moment';
  export default {
    name: "Overwatch-Search",
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        overWatchForm: {
          fromDate: '',
          toDate: '',
          imsiInfo: '',
          tId: '',
          rowLimit: '',
          order: '',
          standard: '',
          type: []
        },
        rowLimitOption: [
          {key: '10', value: '10'},
          {key: '25', value: '25'},
          {key: '50', value: '50'},
          {key: '100', value: '100'}
        ],
        orderOption: [
          {key: 'Ascending', value: 'asc'},
          {key: 'Descending', value: 'desc'}
        ],
        standardOption: [],
        typeOption: [],
        loadingStatus: false,
        actionHistory: [],
      }
    },
    mounted() {
      this.defaultSearchKey();

      this.$root.$on('standardTypeEmit', (res => {
        this.standardOption = res;
      }));

      this.$root.$on('overWatchTypeOption', (type => {
        this.typeOption = type
      }));

      this.$root.$on('lookupIMSIFunc', (imsi => {
        this.overWatchForm.imsiInfo = imsi;
        this.overWatchForm.tId = '';
        this.searchSubmit(true);
      }));

      this.$root.$on('lookupSrcTIdFunc', (tId => {
        this.overWatchForm.imsiInfo = '';
        this.overWatchForm.tId = tId;
        this.searchSubmit(true);
      }));

      this.$root.$on('actionHistorySave', (res => {
        this.saveActionHistory(res.action, res.data)
      }));

      this.$root.$on('revertActionFunc', (res => {
        this.getRevertedAction()
      }))
    },
    methods: {
      defaultSearchKey(createLog = false) {
        overwatchService.getLatestDate().then(res => {
          let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timezone;
          let resDate = new Date((new Date(res + '-0600')).toLocaleString('en-US', {timeZone: userTimeZone}));
          let toDate = new Date(resDate);
          let fromDate = new Date(resDate);
          fromDate.setHours(fromDate.getHours() - 3);
          this.overWatchForm.fromDate = dateFormatDirective.convertDateAsc(fromDate.toLocaleString('en-US', {hour12: false}).replace(',', ''));
          this.overWatchForm.toDate = dateFormatDirective.convertDateAsc(toDate.toLocaleString('en-US', {hour12: false}).replace(',', ''));
          this.overWatchForm.rowLimit = 100;
          this.overWatchForm.order = "asc";
          this.overWatchForm.imsiInfo = '';
          this.overWatchForm.standard = '';
          this.overWatchForm.type = '';
          setTimeout(() => {
            this.$root.$emit('clearOverwatchResult');
          }, 1000);

          if (createLog) {
            this.saveActionHistory('ClearGrid', null)
          }
        });
      },
      searchSubmit(createLog = false) {
        this.loadingStatus = true;
        let serverTimeZone = configDirective.getServerTimeZone();
        let convertFromDate = new Date(this.overWatchForm.fromDate).toLocaleString('en-US', {timeZone: serverTimeZone});
        let convertToDate = new Date(this.overWatchForm.toDate).toLocaleString('en-US', {timeZone: serverTimeZone});
        let newFromDate = dateFormatDirective.convertDateDesc(convertFromDate);
        let newToDate = dateFormatDirective.convertDateDesc(convertToDate);
        let selectType;
        if (this.overWatchForm.type && this.overWatchForm.type.length > 0) {
          for (let i=0; i<this.overWatchForm.type.length; i++) {
            selectType = selectType + ',' + this.typeOption.find(item => item.value === this.overWatchForm.type).key;
          }
          selectType = selectType.split('undefined,')[1]
        } else {
          selectType = ''
        }
        let formData = {
          fromDate: newFromDate,
          toDate: newToDate,
          imsi: this.overWatchForm.imsiInfo?this.overWatchForm.imsiInfo:'',
          tId: this.overWatchForm.tId?this.overWatchForm.tId: '',
          rowLimit: this.overWatchForm.rowLimit,
          order: this.overWatchForm.order? this.overWatchForm.order:'',
          standard: this.overWatchForm.standard?this.overWatchForm.standard:'',
          type: selectType
        };
        if (createLog) {
          this.saveActionHistory('LoadGrid', formData);
        }
        overwatchService.getOverwatchSearch(formData).then(res => {
          this.loadingStatus = false;
          let serverOffset = configDirective.getServerOffSet();
          let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          res.map(item => {
            let curDate = new Date((new Date(item.frame_dt + serverOffset)).toLocaleString('en-US', {timeZone: userTimeZone}));
            let formattedDate = dateFormatDirective.convertDateAscWithoutT(moment(curDate));
            if (formattedDate.indexOf('Invalid') > -1 || formattedDate.indexOf('NaN')>-1 ) {
              //console.warn('Invalid Data Format, reverting to default value. formatted:',formattedDate,' raw:',item.frame_dt);
            } else {
              item.frame_dt = formattedDate
            }
          });
          res.map(item => {
            let relatedTitle = '';
            if (item['src_tid'] && (item['opcode'] === '2' || item['opcode'] === '23')) {
              if (item['opcode'] === '2') {
                relatedTitle = 'GetRelatedISD_UPLOC';
              } else {
                relatedTitle = 'GetRelatedISD_UPGPRS';
              }
            } else if (item['opcode'] === '46') {
              relatedTitle = 'GetRelatedSMS'
            } else {
              relatedTitle = ''
            }
            if (relatedTitle !== '') {
              item['relatedTitle'] = relatedTitle
            }
          });
          //console.log('res:',res);
          this.$root.$emit('renderOverwatchTableData', res)
        })
      },

      saveActionHistory(action, data) {
        this.actionHistory.push({
          action: action,
          data: data
        });
      },

      getRevertedAction() {
        if (this.actionHistory && this.actionHistory.length > 0) {
          let lastAction = this.actionHistory[this.actionHistory.length - 1];
          if (this.actionHistory.action === 'HideCol') {

          } else {
            this.actionHistory.pop();
            if (this.actionHistory.length === 0){
              this.defaultSearchKey(false);
            }
            switch (lastAction.action) {
              case 'LoadGrid':
                this.overWatchForm.fromDate = lastAction.data.fromDate;
                this.overWatchForm.toDate = lastAction.data.toDate;
                this.overWatchForm.imsiInfo = lastAction.data.imsi;
                this.overWatchForm.tId = lastAction.data.tId;
                this.overWatchForm.order = lastAction.order;
                this.overWatchForm.standard = lastAction.standard;
                this.overWatchForm.type = lastAction.type;
                this.searchSubmit(false);
                break;
              case 'ShowDetails':
                setTimeout(() => {
                  this.$root.$emit('emitShowDetails', lastAction)
                }, 400);
                break;
              case 'ClearGrid':
                this.defaultSearchKey(false);
                break;
              case 'ShowRelated':
                setTimeout(() => {
                  this.$root.$emit('emitShowRelated', lastAction)
                }, 400);
                break;
              case 'HideCol':
                this.getRevertedAction();
                break;
              default:
                break;
            }
          }
        }
      },

      reset() {
        this.overWatchForm.type = [];
      }

    }
  }
</script>

<style scoped>

</style>
